/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseDayOff } from '../models/api-response-day-off';
import { ApiResponsePagedResultDayOff } from '../models/api-response-paged-result-day-off';
import { createDayOff } from '../fn/day-off-api/create-day-off';
import { CreateDayOff$Params } from '../fn/day-off-api/create-day-off';
import { deleteDayOff } from '../fn/day-off-api/delete-day-off';
import { DeleteDayOff$Params } from '../fn/day-off-api/delete-day-off';
import { getDayOffByRef } from '../fn/day-off-api/get-day-off-by-ref';
import { GetDayOffByRef$Params } from '../fn/day-off-api/get-day-off-by-ref';
import { searchDayOff } from '../fn/day-off-api/search-day-off';
import { SearchDayOff$Params } from '../fn/day-off-api/search-day-off';
import { updateDayOff } from '../fn/day-off-api/update-day-off';
import { UpdateDayOff$Params } from '../fn/day-off-api/update-day-off';

@Injectable({ providedIn: 'root' })
export class DayOffApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDayOffByRef()` */
  static readonly GetDayOffByRefPath = '/v1/api/ui/dayOff/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDayOffByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDayOffByRef$Response(params: GetDayOffByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDayOff>> {
    return getDayOffByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDayOffByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDayOffByRef(params: GetDayOffByRef$Params, context?: HttpContext): Observable<ApiResponseDayOff> {
    return this.getDayOffByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseDayOff>): ApiResponseDayOff => r.body)
    );
  }

  /** Path part for operation `updateDayOff()` */
  static readonly UpdateDayOffPath = '/v1/api/ui/dayOff/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDayOff()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDayOff$Response(params: UpdateDayOff$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDayOff>> {
    return updateDayOff(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDayOff$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDayOff(params: UpdateDayOff$Params, context?: HttpContext): Observable<ApiResponseDayOff> {
    return this.updateDayOff$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseDayOff>): ApiResponseDayOff => r.body)
    );
  }

  /** Path part for operation `deleteDayOff()` */
  static readonly DeleteDayOffPath = '/v1/api/ui/dayOff/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDayOff()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDayOff$Response(params: DeleteDayOff$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteDayOff(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteDayOff$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDayOff(params: DeleteDayOff$Params, context?: HttpContext): Observable<void> {
    return this.deleteDayOff$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createDayOff()` */
  static readonly CreateDayOffPath = '/v1/api/ui/dayOff';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDayOff()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDayOff$Response(params: CreateDayOff$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDayOff>> {
    return createDayOff(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createDayOff$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDayOff(params: CreateDayOff$Params, context?: HttpContext): Observable<ApiResponseDayOff> {
    return this.createDayOff$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseDayOff>): ApiResponseDayOff => r.body)
    );
  }

  /** Path part for operation `searchDayOff()` */
  static readonly SearchDayOffPath = '/v1/api/ui/dayOff/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchDayOff()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchDayOff$Response(params: SearchDayOff$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultDayOff>> {
    return searchDayOff(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchDayOff$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchDayOff(params: SearchDayOff$Params, context?: HttpContext): Observable<ApiResponsePagedResultDayOff> {
    return this.searchDayOff$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultDayOff>): ApiResponsePagedResultDayOff => r.body)
    );
  }

}
